<div class="survey-job-detail">
    <div class="survey-job-detail-tools-bar">
        <panel-header
            [headerTitle]="headerTitle"
            [actionItems]="headerActions"
            [backButtonIcon]="
                currentviewMode === DetailPanelView.AttachFiles ? 'icon_line_close i24' : 'icon-arrow-back-black i24'
            "
            [disableBackAction]="isJobUpdating"
            (backClick)="goBackFromCurrentView()"
            (actionClick)="handleAction($event)"
        >
        </panel-header>
    </div>

    <ng-container [ngSwitch]="currentviewMode">
        <ng-container *ngSwitchCase="DetailPanelView.Detail">
            <div class="survey-job-detail-content-wrapper scroll-wrapper">
                <custom-scroll>
                    <div class="survey-job-detail-content">
                        <div class="survey-job-detail-header">
                            <survey-job-detail-header
                                [job]="job"
                                [totalFeatureCount]="jobFeatureDetails?.totalCount"
                            ></survey-job-detail-header>
                        </div>
                        <mat-divider></mat-divider>
                        <div class="survey-job-detail-assignees-wrapper">
                            <job-assigned-user [job]="job"></job-assigned-user>
                        </div>
                        <mat-divider></mat-divider>
                        <div class="survey-job-detail-tags-wrapper">
                            <preopen-accordion [header]="'tags'" [useModusIcons]="true">
                                <job-file-tag-chips
                                    [loading]="loadingUpdatedJob"
                                    [files]="tags"
                                    [chipType]="JobAttachmentChipType.Tag"
                                    [noFilesMessage]="'Survey.SurveyJobPanel.JobDetails.Attachments.NoTags'"
                                    [disableRipple]="true"
                                ></job-file-tag-chips>
                            </preopen-accordion>
                        </div>
                        <mat-divider></mat-divider>
                        <div class="survey-job-detail-reports-wrapper">
                            <preopen-accordion
                                [header]="'Survey.SurveyJobPanel.JobDetails.Attachments.ReportsAndExports'"
                                [useModusIcons]="true"
                            >
                                <job-file-tag-chips
                                    [files]="jobReportsAndExports"
                                    [chipType]="JobAttachmentChipType.Report"
                                    [noFilesMessage]="
                                        'Survey.SurveyJobPanel.JobDetails.Attachments.NoReportsAndExports'
                                    "
                                ></job-file-tag-chips>
                            </preopen-accordion>
                        </div>
                        <mat-divider></mat-divider>
                        <div class="survey-job-detail-features-wrapper">
                            <job-layer-list
                                [jobFeatureDetails]="jobFeatureDetails"
                                (selectAllFeatures)="updateFeaturePanelForFeatureSelection()"
                                (zoomToFeatures)="zoomToJobFeatures()"
                            ></job-layer-list>
                        </div>
                        <mat-divider></mat-divider>
                        <div class="survey-job-detail-linked-files-wrapper">
                            <preopen-accordion
                                [header]="'Survey.SurveyJobPanel.JobDetails.Attachments.LinkedProjectData'"
                                [useModusIcons]="true"
                            >
                                <job-file-tag-chips
                                    [loading]="loadingUpdatedJob"
                                    [files]="linkedProjectData"
                                    [chipType]="JobAttachmentChipType.LinkedProjectData"
                                    [noFilesMessage]="
                                        'Survey.SurveyJobPanel.JobDetails.Attachments.NoLinkedProjectData'
                                    "
                                ></job-file-tag-chips>
                            </preopen-accordion>
                        </div>
                        <mat-divider></mat-divider>
                        <div class="survey-job-detail-other-files-wrapper">
                            <preopen-accordion
                                [header]="'Survey.SurveyJobPanel.JobDetails.Attachments.OtherJobAttachments'"
                                [useModusIcons]="true"
                            >
                                <job-file-tag-chips
                                    [files]="jobOtherAttachments"
                                    [chipType]="JobAttachmentChipType.Other"
                                    [noFilesMessage]="
                                        'Survey.SurveyJobPanel.JobDetails.Attachments.NoOtherJobAttachments'
                                    "
                                ></job-file-tag-chips>
                            </preopen-accordion>
                        </div>
                        <mat-divider></mat-divider>
                        <div class="survey-job-detail-job-img-wrapper">
                            <job-image-gallery [loading]="loadingAttachments" [images]="jobImages"></job-image-gallery>
                        </div>
                    </div>
                </custom-scroll>
            </div>
        </ng-container>
        <ng-container *ngSwitchDefault>
            <edit-job-panel
                #editJobPanel
                [job]="job"
                [linkedFiles]="linkedProjectDataFiles"
                (jobUpdated)="onJobUpdated($event)"
                (isJobUpdating)="setJobUpdatingState($event)"
            ></edit-job-panel>
        </ng-container>
    </ng-container>
</div>
